import React from 'react'
import PropTypes from 'prop-types'
import { defaultT } from '../utils/i18n'
import { useUploadLimits, formatSize } from '../utils/uploadLimits'

// Displays the allowed formats and max size of an upload kind ('file', 'image', 'video').
// `formats` (e.g. a field's allowedFormats ['.pdf']) restricts the server list further.
const UploadHint = ({ kind, formats, t = defaultT }) => {
    const limits = useUploadLimits(kind)
    if (!limits) return null

    const fieldFormats = Array.isArray(formats) && formats.length > 0
        ? formats.map(format => format.replace(/^\./, '').toLowerCase())
        : null
    const displayedFormats = fieldFormats
        ? limits.formats.filter(format => fieldFormats.includes(format))
        : limits.formats

    return (
        <div className="Files-upload-hint">
            {t('acceptedFormats', { formats: displayedFormats.map(format => format.toUpperCase()).join(', ') })}
            {' · '}
            {t('maxFileSize', { size: formatSize(limits.maxSize) })}
        </div>
    )
}

UploadHint.propTypes = {
    kind: PropTypes.oneOf(['file', 'image', 'video']).isRequired,
    formats: PropTypes.arrayOf(PropTypes.string),
    t: PropTypes.func
}

export default UploadHint
